<div class="space-y-4" *ngIf="!isLoading">
  <!-- expense -->
  <div class="relative z-1 left-2.5 -mb-4 bg-linear-(--my-gradient12) text-white text-center px-2 py-1 rounded-lg w-50">
    Expense</div>
  <div
    class="w-full bg-fbf1fd border border-483d8b/20 rounded-md xl:rounded-xl pt-8 px-2 pb-2 xl:px-3 xl:pb-3 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-2">
    <!-- Operating & Administrative Expenses -->
    <div class="col-span-1 sm:col-span-3 lg:col-span-4">
      <p class="text-483d8b underline font-bold text-sm lg:text-base capitalize mb-2">Operating & Administrative
        Expenses</p>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2">
        <div class="col-span-1" *ngFor="let i of [0, 1, 2, 3]">
          <ul class="list-disc pl-4 text-4e4e4e text-sm lg:text-base font-normal capitalize space-y-1">
            <li
              *ngFor="let acc of getChunk(getAccountsByGroup('Expense', ['Operating & Administrative Expenses', 'Operating Expenses']), i, 4)">
              <a [routerLink]="['/account-ledger']" [queryParams]="{id: acc.acc_id}"
                class="hover:underline cursor-pointer">
                {{ acc.acc_user_acc }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Non-Operating Expenses -->
    <div class="col-span-1">
      <p class="text-483d8b underline font-bold text-[13px] text-sm lg:text-base capitalize mb-2">Non-Operating Expenses
      </p>
      <ul class="list-disc pl-4 text-4e4e4e text-sm lg:text-base font-normal capitalize space-y-1">
        <li *ngFor="let acc of getAccountsByGroup('Expense', ['Non-Operating Expenses', 'Non Operating Expenses'])">
          <a [routerLink]="['/account-ledger']" [queryParams]="{id: acc.acc_id}" class="hover:underline cursor-pointer">
            {{ acc.acc_user_acc }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- Assets -->
  <div class="relative z-1 left-2.5 -mb-4 bg-linear-(--my-gradient13) text-white text-center px-2 py-1 rounded-lg w-50">
    Assets</div>
  <div
    class="w-full bg-fff1f8 border border-8f014d/20 rounded-md xl:rounded-xl pt-8 px-2 pb-2 xl:px-3 xl:pb-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-2">
    <div class="col-span-1 sm:col-span-3 lg:col-span-3">
      <p class="text-8f014d underline font-bold text-sm lg:text-base capitalize mb-2">Current Assets</p>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
        <div class="col-span-1" *ngFor="let i of [0, 1, 2]">
          <ul class="list-disc pl-4 text-4e4e4e text-sm lg:text-base font-normal capitalize space-y-1">
            <li *ngFor="let acc of getChunk(getAccountsByGroup('Assets', 'Current Assets'), i, 3)">
              <a [routerLink]="['/account-ledger']" [queryParams]="{id: acc.acc_id}"
                class="hover:underline cursor-pointer">
                {{ acc.acc_user_acc }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Fixed Assets -->
    <div class="col-span-1">
      <p class="text-8f014d underline font-bold text-[13px] text-sm lg:text-base capitalize mb-2">Fixed Assets
      </p>
      <ul class="list-disc pl-4 text-4e4e4e text-sm lg:text-base font-normal capitalize space-y-1">
        <li *ngFor="let acc of getAccountsByGroup('Assets', 'Fixed Assets')">
          <a [routerLink]="['/account-ledger']" [queryParams]="{id: acc.acc_id}" class="hover:underline cursor-pointer">
            {{ acc.acc_user_acc }}
          </a>
        </li>
      </ul>
    </div>
    <!-- Other Assets -->
    <div class="col-span-1">
      <p class="text-8f014d underline font-bold text-[13px] text-sm lg:text-base capitalize mb-2">Other Assets
      </p>
      <ul class="list-disc pl-4 text-4e4e4e text-sm lg:text-base font-normal capitalize space-y-1">
        <li *ngFor="let acc of getAccountsByGroup('Assets', 'Other Assets')">
          <a [routerLink]="['/account-ledger']" [queryParams]="{id: acc.acc_id}" class="hover:underline cursor-pointer">
            {{ acc.acc_user_acc }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2">
    <!-- Liabilities  -->
    <div class="col-span-1 sm:col-span-2">
      <div
        class="relative z-1 left-2.5 -mb-4 bg-linear-(--my-gradient14) text-white text-center px-2 py-1 rounded-lg w-50">
        Liabilities</div>
      <div
        class="w-full bg-f1fdf1 border border-018f37/20 rounded-md xl:rounded-xl pt-8 px-2 pb-2 xl:px-3 xl:pb-3 grid grid-cols-1 sm:grid-cols-2 gap-2">
        <!-- Current Liabilities -->
        <div class="col-span-1 ">
          <p class="text-018f37 underline font-bold text-sm lg:text-base capitalize mb-2">Current Liabilities</p>
          <ul class="list-disc pl-4 text-4e4e4e text-sm lg:text-base font-normal capitalize space-y-1">
            <li *ngFor="let acc of getAccountsByGroup('Liabilities', 'Current Liabilities')">
              <a [routerLink]="['/account-ledger']" [queryParams]="{id: acc.acc_id}"
                class="hover:underline cursor-pointer">
                {{ acc.acc_user_acc }}
              </a>
            </li>
          </ul>
        </div>
        <!-- Loans & Long-Term Liabilities -->
        <div class="col-span-1">
          <p class="text-018f37 underline font-bold text-[13px] text-sm lg:text-base capitalize mb-2">Loans & Long-Term
            Liabilities
          </p>
          <ul class="list-disc pl-4 text-4e4e4e text-sm lg:text-base font-normal capitalize space-y-1">
            <li *ngFor="let acc of getAccountsByGroup('Liabilities', 'Loans & Long-Term Liabilities')">
              <a [routerLink]="['/account-ledger']" [queryParams]="{id: acc.acc_id}"
                class="hover:underline cursor-pointer">
                {{ acc.acc_user_acc }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Income  -->
    <div class="col-span-1">
      <div
        class="relative z-1 left-2.5 -mb-4 bg-linear-(--my-gradient15) text-white text-center px-2 py-1 rounded-lg w-50 sm:w-30 lg:w-50">
        Income</div>
      <div
        class="w-full bg-fffff1 border border-c19725/20 rounded-md xl:rounded-xl pt-8 px-2 pb-2 xl:px-3 xl:pb-3 grid grid-cols-1 gap-2">
        <ul class="list-disc pl-4 text-4e4e4e text-sm lg:text-base font-normal capitalize space-y-1">
          <li *ngFor="let acc of getAccountsByGroup('Income', 'Income')">
            <a [routerLink]="['/account-ledger']" [queryParams]="{id: acc.acc_id}"
              class="hover:underline cursor-pointer">
              {{ acc.acc_user_acc }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- Equality  -->
    <div class="col-span-1">
      <div
        class="relative z-1 left-2.5 -mb-4 bg-linear-(--my-gradient16) text-white text-center px-2 py-1 rounded-lg w-50 sm:w-30 lg:w-50">
        Equity</div>
      <div
        class="w-full bg-f1f1fb border border-0d5bab/20 rounded-md xl:rounded-xl pt-8 px-2 pb-2 xl:px-3 xl:pb-3 grid grid-cols-1 gap-2">
        <ul class="list-disc pl-4 text-4e4e4e text-sm lg:text-base font-normal capitalize space-y-1">
          <li *ngFor="let acc of getAccountsByGroup('Equity', 'Equity')">
            <a [routerLink]="['/account-ledger']" [queryParams]="{id: acc.acc_id}"
              class="hover:underline cursor-pointer">
              {{ acc.acc_user_acc }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

</div>

<div *ngIf="isLoading" class="flex justify-center items-center h-64">
  <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-c19725"></div>
</div>